import { IDefaultEmergencyContact } from '../../../../api/types/default-emergency-contact'
import { TTableDataCountDisplay, TTableHeader } from '@reapitform/common-ui'
import dayjs from 'dayjs'

const tableHeader: TTableHeader<IDefaultEmergencyContact>[] = [
  {
    headerTitle: 'TYPE',
    key: 'contactType',
    columnWidth: '120px',
  },
  {
    headerTitle: 'BUSINESS NAME',
    key: 'businessName',
  },
  {
    headerTitle: 'CONTACT NAME',
    key: 'contactName',
  },
  {
    headerTitle: 'MOBILE',
    key: 'mobile',
    columnWidth: '140px',
  },
  {
    headerTitle: 'SETTING',
    key: 'useAsDefault',
    getColumnValue: (data) => {
      if (data.useAsDefault) return 'Default'
      return 'Optional'
    },
    columnWidth: '90px',
  },
  {
    headerTitle: 'LAST UPDATED',
    key: 'lastUpdatedUTC',
    getColumnValue: (data) => dayjs(data.lastUpdatedUTC).format('D MMM YYYY'),
    sortAs: 'LastActionDate',
    sortable: true,
    columnWidth: '140px',
  },
]

const tableCountDisplayConfig: TTableDataCountDisplay = {
  singular: 'Repairer',
  plural: 'Repairers',
}

export const emergencyContactTableConfig = {
  header: tableHeader,
  countDisplay: tableCountDisplayConfig,
  emptyMessages: 'There are no default repairers',
  description:
    'Maintenance repairers are pre-defined contacts for the General Tenancy Agreement. You can choose to include them by default or leave them as optional selections when creating a new agreement.',
}
